<p class="helppoint-title">{{data.title}}</p>
<date-picker [(ngModel)]="data.moment"
    placeholder="{{'ECMR.TRANSPORTDATE.CAPTION' | translate}}">
</date-picker>
<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirm()"
        color="primary">{{'MAINTENANCE.ACCEPT' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()"
        color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>
